/**
Project: Voice Panel (c)
Title: Routing Reducer
Description: Reducer for the routing page
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import {
  ROUTING_POLICIES,
  SELECT_ROUTING_POLICY,
  VOICE_ROUTES,
  DECREMENT_VOICE_ROUTE_PRIORITY,
  INCREMENT_VOICE_ROUTE_PRIORITY,
  UPDATE_VOICE_ROUTE_PRIORITY,
  ASSIGN_VOICE_ROUTE,
  UNASSIGN_VOICE_ROUTE,
  ENABLE_VOICE_ROUTES_UPDATE_BUTTON,
  DISABLE_VOICE_ROUTES_UPDATE_BUTTON,
  ROUTING_DATA_RESET,
  SET_VOICE_ROUTES,
} from "./constants";

const INIT_STATE = {
  routingPolicies: [],
  selectedRoutingPolicy: null,
  voiceRoutes: [],
  voiceRoutesUpdateButtonDisableStatus: true,
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ROUTING_POLICIES:
      return {
        ...state,
        routingPolicies: action.payload,
      };
    case SELECT_ROUTING_POLICY:
      return {
        ...state,
        selectedRoutingPolicy: action.payload,
      };
    case VOICE_ROUTES:
      return {
        ...state,
        voiceRoutes: action.payload.map((route) => ({
          ...route,
          previousStatus: route.routeStatus,
          previousPriority: route.routePriority,
        })),
      };
    case INCREMENT_VOICE_ROUTE_PRIORITY:
      return {
        ...state,
        voiceRoutes: state.voiceRoutes.map((route) => {
          if (route.routeName === action.payload) {
            return Object.assign({}, route, {
              routePriority: route.routePriority - 1,
            });
          }
          return Object.assign({}, route, {});
        }),
      };
    case DECREMENT_VOICE_ROUTE_PRIORITY:
      return {
        ...state,
        voiceRoutes: state.voiceRoutes.map((route) => {
          if (route.routeName === action.payload) {
            return Object.assign({}, route, {
              routePriority: route.routePriority + 1,
            });
          }
          return Object.assign({}, route, {});
        }),
      };
    case ASSIGN_VOICE_ROUTE:
      return {
        ...state,
        voiceRoutes: state.voiceRoutes.map((route) => {
          if (route.routeName === action.payload) {
            return Object.assign({}, route, {
              routeStatus: 1,
            });
          }
          return Object.assign({}, route, {});
        }),
      };
    case UNASSIGN_VOICE_ROUTE:
      return {
        ...state,
        voiceRoutes: state.voiceRoutes.map((route) => {
          if (route.routeName === action.payload) {
            return Object.assign({}, route, {
              routeStatus: 0,
            });
          }
          return Object.assign({}, route, {});
        }),
      };
    case UPDATE_VOICE_ROUTE_PRIORITY:
      return {
        ...state,
        voiceRoutes: state.voiceRoutes.map((route) => {
          if (route.routeName === action.payload.routeName) {
            return Object.assign({}, route, {
              routePriority: action.payload.newPriorityValue,
            });
          }
          return Object.assign({}, route, {});
        }),
      };
    case ENABLE_VOICE_ROUTES_UPDATE_BUTTON:
      return {
        ...state,
        voiceRoutesUpdateButtonDisableStatus: false,
      };
    case DISABLE_VOICE_ROUTES_UPDATE_BUTTON:
      return {
        ...state,
        voiceRoutesUpdateButtonDisableStatus: true,
      };
    case ROUTING_DATA_RESET:
      return INIT_STATE;
      case SET_VOICE_ROUTES:
      return { ...state, voiceRoutes: action.payload };
    default:
      return state;
  }
};
